import { render, staticRenderFns } from "./ProcessSideFilter.vue?vue&type=template&id=687d7670&"
import script from "./ProcessSideFilter.vue?vue&type=script&lang=js&"
export * from "./ProcessSideFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports